import Successful from 'apps/user/GetStarted/Successful';
import React, { useEffect, useState } from 'react';
import setup from '../../../../constants/setup.json';

export default function SuccessfulPage() {
  const [isProcessing, setIsProcessing] = useState(true);
  const [isSettingUpDashboard, setIsSettingUpDashboard] = useState(false);
  const [dashboardCreated, setDashboardCreated] = useState(false);

  useEffect(() => {
    if (isProcessing) {
      setTimeout(() => {
        setIsSettingUpDashboard(true);
        setIsProcessing(false);
      }, 6000);
    }
  }, [isProcessing]);

  useEffect(() => {
    if (isSettingUpDashboard) {
      setTimeout(() => {
        setDashboardCreated(true);
        setIsSettingUpDashboard(false);
      }, 6000);
    }
  }, [isSettingUpDashboard]);

  return (
    <div className="w-full ">
      {isProcessing && (
        <Successful
          title=""
          buttomText="Processing Information"
          animine={setup}
          useCustomCss={false}
        />
      )}
      {isSettingUpDashboard && (
        <Successful
          title="Everything is ready"
          buttomText="Setting up your dashboard"
          useCustomCss={false}
        />
      )}
      {dashboardCreated && (
        <Successful
          title="Dashboard Created"
          showActionButton
          actionLink="/dashboard"
          buttonText="Check your Dashboard"
          useCustomCss={false}
        />
      )}
    </div>
  );
}
